import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/4ee4671c-b52d-43de-81ae-e14c8a90a71a";
export const REGISTER_URL = "https://a.ntrk2.com/7ac7acc5-8016-4df6-be8d-42e2aa8b2f17";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://topph.kzw2a.com/download?id=yvsdzuyze679bkh";

export * from "./codes";
export * from "./context";
